import {OVERVIEWDESIGNER_LOAD_DATA_FOR_QUERY} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import {
    ElusiveData,
    setElusiveData
} from '~/frontend/src/actions/elusiveData';
import dataLoadData from '~/frontend/src/actions/data/loadData';
import {
    LoadDataCommonParameters,
    LoadDataForQueryParameters,
    LoadDataResult
} from '~/shared/src/utilities/modules/overview';
import {MergeMode} from '~/frontend/src/utilities/dataUtils';
import {Query} from '~/shared/src/utilities/query';
import {DataDescriptor} from '~/shared/src/utilities/dataStructure';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {string} dataContext
 * @param {Schema} schema
 * @param {MergeMode} mergeMode='override'
 * @param {Exclude<Query[ 'type' ], 'DataStructure'>} type
 * @param {string} query
 * @param {DataDescriptor[]} columnsToSelect
 * @param {string[]} searchColumns
 * @param {LoadDataCommonParameters} [params]
 * @param {string} [storeLastParamsToUid]
 *
 * @return {Promise<LoadDataResult | false>}
 */
const loadDataForQuery = ( panelKey : string, dataContext : string, schema : Schema, mergeMode : MergeMode = 'override', type : Exclude<Query[ 'type' ], 'DataStructure'>, query : string, columnsToSelect : DataDescriptor[], searchColumns? : string[], params? : LoadDataCommonParameters, storeLastParamsToUid? : string ) : Thunk<Promise<LoadDataResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<LoadDataResult | false> => {
    dispatch( {
        type     : OVERVIEWDESIGNER_LOAD_DATA_FOR_QUERY,
        panelKey,
        dataContext,
        schema,
        mergeMode,
        queryType: type,
        query,
        columnsToSelect,
        searchColumns,
        params
    } );

    const elusiveData                                = getState().elusiveData?.[ panelKey ],
          newElusiveData : ElusiveData               = {
              ...elusiveData
          },
          requestParams : LoadDataForQueryParameters = {
              type,
              query,
              columnsToSelect,
              searchColumns,
              ...params
          };

    let retVal : LoadDataResult | false = false;

    delete newElusiveData.data;
    dispatch( setElusiveData( panelKey, newElusiveData ) );

    await dispatch( dataLoadData(
        'overview/loadDataForQuery',
        dataContext,
        panelKey,
        'loadData',
        schema,
        {
            params           : requestParams,
            mergeMode,
            extraMetaDataKeys: [ 'rowData', 'rowDataMapping', 'total' ]
        },
        false,
        ( data ) => {
            retVal = data as LoadDataResult;

            if ( storeLastParamsToUid ) {
                dispatch( setElusiveData( storeLastParamsToUid, {
                    lastParams: JSON.parse( JSON.stringify( requestParams ) )
                } ) );
            }
        }
    ) );

    return retVal;
}
export type LoadDataForQuery = typeof loadDataForQuery;

export default loadDataForQuery;
